export default __webpack_public_path__ + "static/media/image2.e6f2f103.png";